import { render, staticRenderFns } from "./AdminDevices.vue?vue&type=template&id=3678e95b&scoped=true"
import script from "./AdminDevices.vue?vue&type=script&lang=ts"
export * from "./AdminDevices.vue?vue&type=script&lang=ts"
import style0 from "./AdminDevices.vue?vue&type=style&index=0&id=3678e95b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678e95b",
  null
  
)

export default component.exports